module.exports = __webpack_public_path__ + "img/vaivem-icon.a5912599.svg";